import { render, staticRenderFns } from "./HospitalStats.vue?vue&type=template&id=4d677a46&scoped=true"
import script from "./HospitalStats.vue?vue&type=script&lang=js"
export * from "./HospitalStats.vue?vue&type=script&lang=js"
import style0 from "./HospitalStats.vue?vue&type=style&index=0&id=4d677a46&prod&lang=css"
import style1 from "./HospitalStats.vue?vue&type=style&index=1&id=4d677a46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d677a46",
  null
  
)

export default component.exports